import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWithTokenRefresh } from '../utils/fetchWithTokenRefresh';
import { CREDIT_UPDATE_EVENT } from '../utils/creditManager';
import Logo from '../icons/vslogo.png';

export default function DashHeader() {
  const [credits, setCredits] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const navigate = useNavigate();

  const fetchUserData = async () => {
    try {
      // Fetch credits
      const creditsResponse = await fetchWithTokenRefresh(
        "https://api.vidstudio.ai/user/credits",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const creditsData = await creditsResponse.json();
      if (creditsResponse.ok) {
        setCredits(creditsData.credits);
      } else {
        console.error("Failed to fetch credits:", creditsData.message);
        setCredits("Error");
      }

      // Fetch subscription info
      const subscriptionResponse = await fetchWithTokenRefresh(
        "https://api.vidstudio.ai/user/subscription",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const subscriptionData = await subscriptionResponse.json();
      if (subscriptionResponse.ok) {
        setSubscriptionStatus(subscriptionData.status);
      } else {
        console.error("Failed to fetch subscription:", subscriptionData.message);
        setSubscriptionStatus("inactive");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setCredits("Error");
      setSubscriptionStatus("Error");
    }
  };

  useEffect(() => {
    fetchUserData();

    // Add event listener for credit updates
    window.addEventListener(CREDIT_UPDATE_EVENT, fetchUserData);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener(CREDIT_UPDATE_EVENT, fetchUserData);
    };
  }, []);

  const handleUpgrade = () => {
    navigate("/profile");
  };

  const renderCreditsOrUpgrade = () => {
    if (credits === null) {
      return (
        <div className="bg-black text-white rounded-full px-3 py-1 text-sm font-semibold">
          Loading...
        </div>
      );
    } else if (credits === 0) {
      return (
        <button
          onClick={handleUpgrade}
          className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 text-white rounded-full px-3 py-1 text-sm font-semibold hover:from-blue-500 hover:to-blue-700 transition-all duration-300"
        >
          Upgrade
        </button>
      );
    } else if (credits === "Error") {
      return (
        <div className="bg-red-500 text-white rounded-full px-3 py-1 text-sm font-semibold">
          Error
        </div>
      );
    } else {
      return (
        <div className="bg-black text-white rounded-full px-3 py-1 text-sm font-semibold">
          {credits}
        </div>
      );
    }
  };

  return (
    <div className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200">
      <div className="flex items-center">
        <img src={Logo} alt="VidStudio" className="h-8 w-auto" />
      </div>
      <div className="flex items-center space-x-4">
        {renderCreditsOrUpgrade()}
        <span
          onClick={handleUpgrade}
          className="text-sm font-semibold text-black cursor-pointer"
        >
          Account
        </span>
      </div>
    </div>
  );
} 